import { Component, OnInit, NgModule } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { startWith } from 'rxjs/operators/startWith';
import Swal from 'sweetalert2';
import { Global } from '../../global';
import { ApiSemLoginService } from '../../services/apiSemLogin.service';

import {
  Router,
  NavigationStart,
  NavigationEnd,
  ActivatedRoute,
  Event as NavigationEvent
} from "@angular/router";

@Component({
  selector: 'app-nova-senha',
  templateUrl: './nova-senha.component.html',
  styleUrls: ['./nova-senha.component.css']
})
export class NovaSenhaComponent implements OnInit {
  bearer: any;
  loading: any;
  nova: any = {};

  constructor(
    private apiService: ApiSemLoginService,
    public global: Global,
    public dialog: MatDialog,
    private router: Router,
    public route: ActivatedRoute
  ) {
    this.global.token_acesso = this.route.snapshot.queryParams.op;
  }

  ngOnInit() {
  }

  valido() {
    debugger
    if (this.nova.senha == null || this.nova.senha == "") {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Informe a nova senha'
      });
      return false;
    }
    if (this.nova.repete == null || this.nova.repete == "") {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Confirme sua nova senha'
      });
      return false;
    }
    if (this.nova.senha != this.nova.repete) {
      Swal.fire({
        type: 'error',
        title: 'Oops...',
        text: 'Senhas informadas não são iguais. Confirme sua nova senha'
      });
      return false;
    }
    return true; 
  }

  submit() {
    this.loading = true;
    if (this.valido()) {
      this.apiService.Post("Auths/NovaSenha", this.global.md5Normal(this.nova.senha)).then(
        result => {
          Swal.fire({
            type: 'success',
            title: 'Sucesso!',
            text: 'Sua senha foi atualizada com sucesso'
          });
          this.router.navigate(['/login']);
        },
        err => {
          this.loading = false;
          Swal.fire({
            type: 'error',
            title: 'Oops...',
            text: err.error.mensagem
          });
        }
      );
    }
    else {
      this.loading = false;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/nova-senha/nova-senha.component.ts